<!--  -->
<template>
  <div>
    <div class="tencent-video-time">
      <!-- <div class="dis-24">辅导开始时间：{{appDetail.menteeResultTimeStr}} （{{appDetail.menteeZone | zoneTitleMap}}）</div> -->
      <div class="dis-12">
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | appModuleTitleMap }}</span><span style="padding-left:20px;"></span>剩余时间：{{(remainTime.remainTime>0)?remainTime.remainTime:0}}mins</div>
        <!-- dis-48 -->
      <!-- <div class="dis-24">已进行的时间：{{Math.floor(usedTime/60)}}mins</div> -->
      <div class="dis-12">
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | appModuleTitleMap }}</span><span style="padding-left:20px;"></span>上限时间：{{remainTime.maxTime}}mins</div>
        <!-- dis-48 -->
      <div class="dis-24">已使用时间：{{remainTime.usedTime}}mins</div>
    </div>
    <div class="tencent-video-btn" style="margin-top:30px;">
      <Button class="zlr-btn-default"
              @click="handleReplaceDiy">置换时间</Button>
      <Button class="zlr-btn-primary endTime"
              @click="isEndTime = true"
              v-if="isLinkVideo">结束辅导</Button>
    </div>
    <!-- 模块1-3 -->
    <replace-book ref="replaceBook"
                  @on-success="handleReplaceSuc"></replace-book>
    <!-- 模块7.8 -->
    <replace-diy ref="repalceDiy"
                 @on-success="handleReplaceSuc"></replace-diy>
    <!-- 确定要结束时间吗 -->
    <zlr-modal v-model="isEndTime">
      <div class="sure-video-end">
        <h1>确定要结束辅导吗</h1>
        <div class="sur-video-btn">
          <Button class="zlr-btn-default"
                  @click="isEndTime = false">取消</Button>
          <Button class="zlr-btn-primary"
                  @click="handleEnd">确定</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>
<script>
// api
import { getAppRemainTime } from '@/api/appointment'
// components
import ReplaceDiy from '../replace-diy'
import ReplaceBook from '../replace-book'
import ZlrModal from '_c/modal/modal'
export default {
  name: 'tencent-app-time',
  components: {
    ReplaceDiy,
    ZlrModal,
    ReplaceBook
  },
  props: ['appDetail', 'isLinkVideo', 'usedTime', 'isPackageId'],
  data () {
    return {
      remainTime: {},
      isEndTime: false
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'jointId': appDetail.jointId,
        'module': appDetail.module,
        'appointmentType': appDetail.type
      }).then(res => {
        this.remainTime = res.data.model
      })
    },
    // 置换时间
    handleReplaceDiy () {
      let modules = this.appDetail.module
      if (['MODULE_1', 'MODULE_2', 'MODULE_3'].includes(modules)) {
        this.$refs['replaceBook'].showHandle()
      }
      if (['MODULE_7', 'MODULE_8'].includes(modules)) {
        this.$refs['repalceDiy'].showHandle()
      }
    },
    // 置换成功
    handleReplaceSuc () {
      this.getAppRemainTime()
      this.$emit('on-repalce-suc')
    },
    // 确定断开连接
    handleEnd () {
      this.isEndTime = false
      this.$emit('on-close')
    }
  },
  watch: {
    appDetail () {
      this.getAppRemainTime()
    }
  }
}
</script>
<style lang='less' scoped>
.endTime {
  margin-left: 70px;
}
.sure-video-end {
  h1 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    margin-bottom: 40px;
  }
  .sur-video-btn {
    text-align: center;
    button {
      margin: 0 20px;
    }
  }
}
</style>
